<template>
  <div style="position: relative;">
    <el-form ref="AttnFlowListFilter" :model="AttnFlowList" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">

        <el-form-item label="人员名称" prop="formFilter.userName">
          <el-input class="filter-item" v-model="AttnFlowList.formFilter.userName"
                    :clearable="true" placeholder="请输入参与人员名称"
          />
        </el-form-item>

        <el-form-item label="部门" prop="formFilter.bumenmingcheng">
          <el-select class="filter-item" v-model="AttnFlowList.formFilter.bumenmingcheng" :clearable="true" filterable
            placeholder="选择部门" :loading="AttnFlowList.daleimingchengLv.impl.loading"
            @visible-change="AttnFlowList.daleimingchengLv.impl.onVisibleChange"
            @change="onAssessLvValueChange">
            <el-option v-for="item in AttnFlowList.daleimingchengLv.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>

        <el-form-item label="考勤组" prop="formFilter.kaoqingzu">
          <el-select class="filter-item" v-model="AttnFlowList.formFilter.kaoqingzu" :clearable="true" filterable
                     placeholder="选择考勤组" :loading="AttnFlowList.daleikaoqingzuLv.impl.loading"
                     @visible-change="AttnFlowList.daleikaoqingzuLv.impl.onVisibleChange"
                     @change="onAssessLvValueChange">
            <el-option v-for="item in AttnFlowList.daleikaoqingzuLv.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>

        <el-form-item label="状态" prop="formFilter.language">
          <el-select class="filter-item" v-model="AttnFlowList.formFilter.status" :clearable="true" filterable placeholder="状态">
              <el-option v-for="item in AttnFlowList.languageLv"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="开始时间" prop="formFilter.language">
          <div class="block">
            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="filter-item" v-model="AttnFlowList.formFilter.kaishishijian" type="date" placeholder="选择开始日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="结束时间" prop="formFilter.language">
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="filter-item" v-model="AttnFlowList.formFilter.jiesushijian" type="date" placeholder="选择结束日期">
          </el-date-picker>
        </el-form-item>
        <!-- ziyi 2022年6月11日 end -->
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetUserWorkList">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="onExportClick()">导出</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshUserWorkList(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="AttnFlowLine" :data="AttnFlowList.AttnFlowLine.impl.dataList" :size="defaultFormItemSize" @sort-change="AttnFlowList.AttnFlowLine.impl.onSortChange"
          header-cell-class-name="table-header-gray" height="600px"
          highlight-current-row @current-change="AttnFlowList.AttnFlowLine.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="AttnFlowList.AttnFlowLine.impl.getTableIndex" />
          <el-table-column label="状态" prop="statusDictMap.name">
          </el-table-column>
          <el-table-column label="类型" prop="type" width="120px">
          </el-table-column>
          <el-table-column label="员工姓名" prop="userName" width="130px">
          </el-table-column>
          <el-table-column label="部门名称" prop="deptName" width="120px">
          </el-table-column>
          <el-table-column label="描述" prop="detail" width="200px">
          </el-table-column>
          <el-table-column label="开始时间" prop="startTime" width="200px">
          </el-table-column>
          <el-table-column label="结束时间" prop="endTime" width="200px">
          </el-table-column>
          <el-table-column label="审批人" prop="approvalUserName">
          </el-table-column>
          <el-table-column label="审批时间" prop="approvalTime" width="200px">
          </el-table-column>
          <el-table-column label="是否同意" prop="approvalFlag">
          </el-table-column>
          <el-table-column label="审批意见" prop="approvalDetail" width="100px">
          </el-table-column>
          <el-table-column label="备注" prop="remark">
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="AttnFlowList.AttnFlowLine.impl.totalCount"
            :current-page="AttnFlowList.AttnFlowLine.impl.currentPage"
            :page-size="AttnFlowList.AttnFlowLine.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="AttnFlowList.AttnFlowLine.impl.onCurrentPageChange"
            @size-change="AttnFlowList.AttnFlowLine.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import {DictionaryController, PaAttnFlowController} from '@/api';

export default {
  name: 'AttnFlowList',
  props: {
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      AttnFlowList: {
        formFilter: {
          status: undefined,
          language: undefined,
          kaishishijian: undefined,
          jiesushijian: undefined,
          bumenmingcheng: undefined,
          kaoqingzu: undefined,
          userName: undefined
        },
        formFilterCopy: {
          status: undefined,
          language: undefined,
          kaishishijian: undefined,
          jiesushijian: undefined,
          bumenmingcheng: undefined,
          kaoqingzu: undefined,
          userName: undefined
        },
        AttnFlowLine: {
          impl: new TableWidget(this.loadPaWorkLineWidgetData, this.loadPaWorkLineVerify, true, true, 'updateTime', 0)
        },
        daleimingchengLv: {
           impl: new DropdownWidget(this.loaddaleimingchengLvDropdownList)
        },

        daleikaoqingzuLv: {
          impl: new DropdownWidget(this.loaddaleikaoqingzuLvDropdownList)
        },

        languageLv: [{
             value: 'wait_approval',
             label: '待审批'
           }, {
             value: 'completed',
             label: '已完成'
        }],

        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetUserWorkList () {
      this.$refs.AttnFlowListFilter.resetFields();
      this.refreshUserWorkList(true);
    },
    /**
     * 作品行数据获取函数，返回Promise
     */
    loadPaWorkLineWidgetData (params) {
      if (params == null) params = {};
      if (this.AttnFlowList.formFilterCopy.kaishishijian && this.AttnFlowList.formFilterCopy.jiesushijian) {
        if (new Date(this.AttnFlowList.formFilterCopy.kaishishijian).getTime() > new Date(this.AttnFlowList.formFilterCopy.jiesushijian).getTime()) {
          this.$message.error('操作失败!开始时间 不能大于 结束时间!');
          return;
        }
      }

      params = {
        ...params,
        paAttnFlowDtoFilter: {
          status: this.AttnFlowList.formFilterCopy.status,
          kaishishijian:this.AttnFlowList.formFilterCopy.kaishishijian,
          jiesushijian:this.AttnFlowList.formFilterCopy.jiesushijian,
          deptId:this.AttnFlowList.formFilterCopy.bumenmingcheng,
          attnGroupId:this.AttnFlowList.formFilterCopy.kaoqingzu,
          userName:this.AttnFlowList.formFilterCopy.userName
        }
      }
      return new Promise((resolve, reject) => {
        PaAttnFlowController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.AttnFlowList.AttnFlowLine.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.AttnFlowList.AttnFlowLine.impl.currentRow.id, 'id');
              this.$refs.AttnFlowLine.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品行数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaWorkLineVerify () {
      this.AttnFlowList.formFilterCopy.status = this.AttnFlowList.formFilter.status;
      this.AttnFlowList.formFilterCopy.kaishishijian = this.AttnFlowList.formFilter.kaishishijian;
      this.AttnFlowList.formFilterCopy.jiesushijian = this.AttnFlowList.formFilter.jiesushijian;
      this.AttnFlowList.formFilterCopy.bumenmingcheng = this.AttnFlowList.formFilter.bumenmingcheng;
      this.AttnFlowList.formFilterCopy.kaoqingzu = this.AttnFlowList.formFilter.kaoqingzu;
      this.AttnFlowList.formFilterCopy.userName = this.AttnFlowList.formFilter.userName;
      return true;
    },
    /**
     * 作品评级下拉数据获取函数
     */
    loadAssessLvDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_work_assess_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    //部门名称下拉选择器
    loaddaleimingchengLvDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDictDaLeiMingCheng(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },

    //考勤组名称下拉选择器
    loaddaleikaoqingzuLvDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictPaAttnGroup(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品评级选中值改变
     */
    onAssessLvValueChange (value) {
      console.log("value-->" + value)
    },
    /**
     * 更新人员作品列表
     */
    refreshUserWorkList (reloadData = false) {
      if (reloadData) {
        this.AttnFlowList.AttnFlowLine.impl.refreshTable(true, 1);
      } else {
        this.AttnFlowList.AttnFlowLine.impl.refreshTable();
      }
      if (!this.AttnFlowList.isInit) {
        // 初始化下拉数据
      }
      this.AttnFlowList.isInit = true;
    },
    /**
     * 导出
     */
    onExportClick () {
      this.loadPaWorkLineVerify();
      let params = {};
      if (this.AttnFlowList.formFilterCopy.kaishishijian && this.AttnFlowList.formFilterCopy.jiesushijian) {
        if (new Date(this.AttnFlowList.formFilterCopy.kaishishijian).getTime() > new Date(this.AttnFlowList.formFilterCopy.jiesushijian).getTime()) {
          this.$message.error('操作失败!开始时间 不能大于 结束时间!');
          return;
        }
      }
      params = {
        paAttnFlowDtoFilter: {
          status: this.AttnFlowList.formFilterCopy.status,
          kaishishijian:this.AttnFlowList.formFilterCopy.kaishishijian,
          jiesushijian:this.AttnFlowList.formFilterCopy.jiesushijian,
          deptId:this.AttnFlowList.formFilterCopy.bumenmingcheng,
          attnGroupId:this.AttnFlowList.formFilterCopy.kaoqingzu,
          userName:this.AttnFlowList.formFilterCopy.userName
        }
        //, ...params
      }
      PaAttnFlowController.export(this, params, '请假记录.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    onResume () {
      this.refreshUserWorkList();
    },
    initFormData () {
    },
    formInit () {
      this.refreshUserWorkList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
